import { render } from "./IndexFooter.vue?vue&type=template&id=381bdacb"
import script from "./IndexFooter.vue?vue&type=script&lang=js"
export * from "./IndexFooter.vue?vue&type=script&lang=js"
script.render = render

export default script